module.exports = __webpack_public_path__ + "img/bowler-hats.f2c617a4.webp";